// removed by extract-text-webpack-plugin
module.exports = {"cinemaGraphVideo":"nrk-du-saa-meg-cinemaGraphVideo"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/CinemaGraph/cinemaGraph.css
// module id = 247
// module chunks = 1